<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modalMaxiItem">

          <div class="modal-header">
            <slot name="header">
              <div class="text-center">
                <b>Max Items {{ role }}</b>
              </div>

              <i @click="$emit('close')" style="cursor: pointer;" class="fas fa-times float-right"></i>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <!-- Addresses -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsAddresses">Addresses</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleAddresses" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Previous Addresses -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsPreviousAddresses">Previous Addresses</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRolePreviousAddresses" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Phones -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsPhones">Phones</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRolePhones" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Jobs -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsJobs">Jobs</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleJobs" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Educational -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsEducational">Educational</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleEducational" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Criminal -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsCriminal">Criminal</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleCriminal" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Eads -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsEads">Work Permit</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleWorkPermit" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Passports -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsPassports">Passports</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRolePassports" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Travel -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsTravel">Travel</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleTravel" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Us Entries -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsUsEntries">Us Entries</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleUsEntries" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Visa -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsVisa">Visa</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleVisa" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Marriage -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsMarriage">Marriage</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleMarriage" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Family -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsFamily">Family</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleFamily" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Family Child -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsChild">Child</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleChild" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Family Sibling -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsSibling">Sibling</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleSibling" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Family Other -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsOther">Family Other</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleFamilyOther" class="form-control float-right" type="text">
                </div>
              </div>

              <br>

              <!-- Advance -->

              <div class="row">
                <div class="col-sm-10">
                  <label style="margin-top: 5px;" class="float-left" for="maxItemsAdvance">Advance</label>
                </div>
                
                <div class="col-sm-2">
                  <input v-model="maxRoleAdvance" class="form-control float-right" type="text">
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-secondary" @click="$emit('close')">
                Close
              </button>
              <button class="btn btn-success" @click="saveMaxItemsRole">
                Save
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import qs from 'qs'

export default {
  name: 'max-items-modal',

  data () {
    return {
      maxRoleAddresses: 0,
      maxRolePreviousAddresses: 0,
      maxRolePhones: 0,
      maxRoleJobs: 0,
      maxRoleEducational: 0,
      maxRoleCriminal: 0,
      maxRoleWorkPermit: 0,
      maxRolePassports: 0,
      maxRoleTravel: 0,
      maxRoleUsEntries: 0,
      maxRoleVisa: 0,
      maxRoleMarriage: 0,
      maxRoleFamily: 0,
      maxRoleChild: 0,
      maxRoleSibling: 0,
      maxRoleFamilyOther: 0,
      maxRoleAdvance: 0
    }
  },

  props: {
    role: {
      type: String
    },

    formId: {
      type: String
    },

    maxItems: {
      type: Object
    }
  },

  created () {
    this.getMaxItemsRole()
  },

  methods: {
    getMaxItemsRole () {
      if (this.maxItems !== undefined) {
        this.maxRoleAddresses = this.maxItems.address !== null && this.maxItems.address !== undefined ? this.maxItems.address : 0
        this.maxRolePreviousAddresses = this.maxItems.previousAddress !== null && this.maxItems.previousAddress !== undefined ? this.maxItems.previousAddress : 0
        this.maxRolePhones = this.maxItems.phones !== null && this.maxItems.phones !== undefined ? this.maxItems.phones : 0
        this.maxRoleJobs = this.maxItems.jobs !== null && this.maxItems.jobs !== undefined ? this.maxItems.jobs : 0
        this.maxRoleEducational = this.maxItems.educationalHistory !== null && this.maxItems.educationalHistory !== undefined ? this.maxItems.educationalHistory : 0
        this.maxRoleCriminal = this.maxItems.criminalHistory !== null && this.maxItems.criminalHistory !== undefined ? this.maxItems.criminalHistory : 0
        this.maxRoleWorkPermit = this.maxItems.ead !== null && this.maxItems.ead !== undefined ? this.maxItems.ead : 0
        this.maxRolePassports = this.maxItems.passports !== null && this.maxItems.passports !== undefined ? this.maxItems.passports : 0
        this.maxRoleTravel = this.maxItems.travelHistory !== null && this.maxItems.travelHistory !== undefined ? this.maxItems.travelHistory : 0
        this.maxRoleUsEntries = this.maxItems.usEntries !== null && this.maxItems.usEntries !== undefined ? this.maxItems.usEntries : 0
        this.maxRoleVisa = this.maxItems.visaHistory !== null && this.maxItems.visaHistory !== undefined ? this.maxItems.visaHistory : 0
        this.maxRoleMarriage = this.maxItems.marriageHistory !== null && this.maxItems.marriageHistory !== undefined ? this.maxItems.marriageHistory : 0
        this.maxRoleFamily = this.maxItems.familyMembers !== null && this.maxItems.familyMembers !== undefined ? this.maxItems.familyMembers : 0
        this.maxRoleChild = this.maxItems.familyChild !== null && this.maxItems.familyChild !== undefined ? this.maxItems.familyChild : 0
        this.maxRoleSibling = this.maxItems.familySibling !== null && this.maxItems.familySibling !== undefined ? this.maxItems.familySibling : 0
        this.maxRoleFamilyOther = this.maxItems.familyOther !== null && this.maxItems.familyOther !== undefined ? this.maxItems.familyOther : 0
        this.maxRoleAdvance = this.maxItems.advanceParole !== null && this.maxItems.advanceParole !== undefined ? this.maxItems.advanceParole : 0
      }
    },

    saveMaxItemsRole () {
      let formMaxItemsRole = {}

      formMaxItemsRole[this.role] = {
        address: Number(this.maxRoleAddresses),
        previousAddress: Number(this.maxRolePreviousAddresses),
        phones: Number(this.maxRolePhones),
        jobs: Number(this.maxRoleJobs),
        educationalHistory: Number(this.maxRoleEducational),
        criminalHistory: Number(this.maxRoleCriminal),
        ead: Number(this.maxRoleWorkPermit),
        passports: Number(this.maxRolePassports),
        travelHistory: Number(this.maxRoleTravel),
        usEntries: Number(this.maxRoleUsEntries),
        visaHistory: Number(this.maxRoleVisa),
        marriageHistory: Number(this.maxRoleMarriage),
        familyMembers: Number(this.maxRoleFamily),
        familyChild: Number(this.maxRoleChild),
        familySibling: Number(this.maxRoleSibling),
        familyOther: Number(this.maxRoleFamilyOther),
        advanceParole: Number(this.maxRoleAdvance)
      }

      if (this.formId !== undefined) {
        let formData = {
          formId: this.formId,
          newData: formMaxItemsRole
        }

        const apiUrl = this.$store.state.apiUrl

        this.axios.post(apiUrl + 'form/update-item', qs.parse(formData)).then(response => {
          if (response.data.success) {
            this.$bus.emit('addNotification', {
              title: 'Form Updated',
              body: 'The form was updated successfully.',
              type: 'success'
            })

            this.$emit('update-maxitems', formData.newData[this.role])

            this.$emit('close')
          } else {
            this.$bus.emit('addNotification', {
              title: 'Update Error',
              body: 'There was an error updating this form. Please check the data and try again.',
              type: 'success'
            })
          }
        })
      } else {
        this.$emit('update-maxitems', formMaxItemsRole[this.role])

        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
  .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 700px;
  height: 800px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modalMaxiItem{
  overflow-y: auto;
  height: 650px;
}

@media (min-height: 940px){
  .modalMaxiItem{
    overflow-y: auto;
    height: 800px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form-grid/MaxItemsModal.vue